module.exports = __webpack_public_path__ + "img/oneGreen.37b91d5f.jpg";